module.exports = __webpack_public_path__ + "static/media/pubninja-logo.7442e235.png";